import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ComingSoonLabelComponent } from '../components';

@Component({
  selector: 'rp-home-legal-support-schema',
  standalone: true,
  templateUrl: './legal-support-schema.component.html',
  styleUrl: './../schema.base.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ComingSoonLabelComponent],
})
export class LegalSupportSchemaComponent {}
